<script setup lang="ts">
import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import {ref, defineProps, watch, computed} from 'vue'
import Modal from '@/onenetwork/components/modal/Modal.vue'
import { GoogleMap, Polygon } from 'vue3-google-map'
import { Icon } from '@iconify/vue'


interface Props {
  data: {
    title: string
    center: {
      lat: number,
      lng: number,
    },
    coordinates: Array<Array<number>>,
  }
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()
const isOpenModal = ref<boolean>(false)

const triangleCoords = ref<Array<{ lat: number, lng: number }>>([])

const title = computed(()=>{
  const data = [];
  if(props.data?.item?.district?.full_name) data.push(props.data?.item?.district?.full_name)
  if(props.data?.item?.province?.full_name) data.push(props.data?.item?.province?.full_name)

  return `Thửa ${props.data?.item?.plot_number} tờ bản đồ ${props.data?.item?.map_sheet_number} | ${data.join(', ')}`;
})

watch(
  () => props.data?.coordinates,
  (newValue) => {
    if (newValue && newValue.length > 0) {
      triangleCoords.value = newValue.map((point: Array<number>) => ({
        lat: point[1],
        lng: point[0],
      }))
    }
  },
  { immediate: true },
)

</script>

<template>
  <div class="table-cell coordinate-cell">
    <div @click="isOpenModal = true" class="preview-btn">
      <Icon icon="streamline-sharp:map-search-solid" /> xem bản đồ
    </div>
    <Modal :show="isOpenModal" :title="title" @on:close="()=>{isOpenModal = false}">
      <GoogleMap
        :api-key="OneNetworkConfig.map.apiKey"
        :center="props.data?.center"
        :zoom="18"
        style="width: 100%; height: 400px"
      >
        <Polygon
          :options="{
            paths: triangleCoords,
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
          }"
        />
      </GoogleMap>
    </Modal>
  </div>
</template>

<style lang="scss">
.coordinate-cell{
  .preview-btn{
    display: flex;
    align-items: center;
    gap: 2px;
    cursor: pointer;
    padding: 3px 7px;
    background: #c3f4ff;
    border-radius: 8px;
    font-size: 10px;
    &:hover{
      background: #0074b1;
      color: #fff;
    }
  }
}
</style>
